import { OrganizationGroupRole } from 'generated-graphql/graphql';
import { useRecoilValue } from 'recoil';
import { userAtom } from 'services/user/atoms';

export const useIsOrganizationGroupAdmin = () => {
  const user = useRecoilValue(userAtom);

  return (
    user?.organizationGroupRole === OrganizationGroupRole.OrganizationGroupAdmin
  );
};
